import * as React from 'react';
import NextHead from 'next/head';
import { useRouter } from 'next/router';
import { LANGUAGES_SSR } from 'docs/config';
import { useUserLanguage, useTranslate } from '@mui/docs/i18n';
import { pathnameToLanguage } from 'docs/src/modules/utils/helpers';

// #host-reference
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HOST = process.env.PULL_REQUEST_ID ? "https://deploy-preview-".concat(process.env.PULL_REQUEST_ID, "--").concat(process.env.NETLIFY_SITE_NAME, ".netlify.app") : 'https://mui.com';
export default function Head(props) {
  var t = useTranslate();
  var _props$card = props.card,
    card = _props$card === void 0 ? '/static/social-previews/home-preview.jpg' : _props$card,
    children = props.children,
    _props$description = props.description,
    description = _props$description === void 0 ? t('strapline') : _props$description,
    _props$disableAlterna = props.disableAlternateLocale,
    disableAlternateLocale = _props$disableAlterna === void 0 ? false : _props$disableAlterna,
    _props$largeCard = props.largeCard,
    largeCard = _props$largeCard === void 0 ? true : _props$largeCard,
    _props$title = props.title,
    title = _props$title === void 0 ? t('headTitle') : _props$title,
    _props$type = props.type,
    type = _props$type === void 0 ? 'website' : _props$type;
  var userLanguage = useUserLanguage();
  var router = useRouter();
  var _pathnameToLanguage = pathnameToLanguage(router.asPath),
    canonicalAs = _pathnameToLanguage.canonicalAs;
  var preview = card.startsWith('http') ? card : "".concat(HOST).concat(card);
  return /*#__PURE__*/_jsxs(NextHead, {
    children: [/*#__PURE__*/_jsx("title", {
      children: title
    }), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: largeCard ? 'summary_large_image' : 'summary'
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:site",
      content: "@MUI_hq"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: title
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: description
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: preview
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: type
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: title
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: "".concat(HOST).concat(router.asPath)
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: description
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: preview
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:ttl",
      content: "604800"
    }), /*#__PURE__*/_jsx("meta", {
      name: "docsearch:language",
      content: userLanguage
    }), /*#__PURE__*/_jsx("meta", {
      name: "docsearch:version",
      content: "master"
    }), disableAlternateLocale ? null : LANGUAGES_SSR.map(function (userLanguage2) {
      return /*#__PURE__*/_jsx("link", {
        rel: "alternate",
        href: "https://mui.com".concat(userLanguage2 === 'en' ? '' : "/".concat(userLanguage2)).concat(canonicalAs),
        hrefLang: userLanguage2
      }, userLanguage2);
    }), children]
  });
}